/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./downlinks.vue?vue&type=template&id=1eb25d85&scoped=true"
import script from "./downlinks.vue?vue&type=script&lang=js"
export * from "./downlinks.vue?vue&type=script&lang=js"
import style0 from "./downlinks.vue?vue&type=style&index=0&id=1eb25d85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb25d85",
  null
  
)

export default component.exports